import React from "react";
import "./styles.scss";
import PropTypes from "prop-types";
import { GetIconByName } from "../../config/icon";

const Index = ({ data, onClick }) => {
  let inputElement = null;
  inputElement = (
    <>
      <div
        className={`form-check-box-wrapper ${data.type} ${
          data.disabled ? "disabled" : ""
        } ${data.isSelect ? "active-me" : ""}`}
        onClick={onClick}
      >
        <div className={"fcb_w__icon"}>{GetIconByName(`${data.iconName}`)}</div>
      </div>
    </>
  );
  return <>{inputElement}</>;
};

Index.propTypes = {};

Index.defaultProps = {};
export default Index;
